
import React, { useState } from "react";
import Select from "react-select";
import { useTheme } from "../CommonComponents/ThemeProvider";
import PrimaryButton from "../CommonComponents/PrimaryButton";

export default function AppearanceSection() {
  const { themeId, setThemeId, themes, currentTheme } = useTheme();
  const [selectedTheme, setSelectedTheme] = useState(themeId);
  const [showConfirmation, setShowConfirmation] = useState(false);

  // Find the theme object for preview
  const previewTheme = themes.find(t => t.id === selectedTheme) || currentTheme;

  const handleThemeChange = (e) => {
    setSelectedTheme(e.target.value);
    setShowConfirmation(true);
  };

  const handleConfirm = () => {
    setThemeId(selectedTheme);
    setShowConfirmation(false);
  };

  const handleCancel = () => {
    setSelectedTheme(themeId);
    setShowConfirmation(false);
  };

  return (
    <div className="flex flex-col gap-6 px-5 pb-5">
      <div>
        <label htmlFor="theme-select" className="block text-sm font-medium text-gray-700 mb-2">
          Select Theme
        </label>
        <Select
          inputId="theme-select"
          value={themes.find(t => t.id === selectedTheme)}
          onChange={option => {
            setSelectedTheme(option.id);
            setShowConfirmation(true);
          }}
          options={themes}
          getOptionLabel={option => option.name}
          getOptionValue={option => option.id}
          styles={{
            control: (base, state) => ({
              ...base,
              background: previewTheme.background || '#fff',
              color: previewTheme.textColor || 'var(--color-text)',
              borderColor: previewTheme.color,
              boxShadow: `0 0 0 2px ${previewTheme.color}22`,
              minHeight: 48,
            }),
            singleValue: (base) => ({
              ...base,
              color: previewTheme.textColor || 'var(--color-text)',
            }),
            option: (base, state) => ({
              ...base,
              background: state.isSelected
                ? previewTheme.color
                : state.isFocused
                ? previewTheme.color + '22'
                : previewTheme.background || '#fff',
              color: state.isSelected
                ? '#fff'
                : previewTheme.textColor || 'var(--color-text)',
              fontWeight: state.isSelected ? 600 : 400,
            }),
            menu: (base) => ({
              ...base,
              background: previewTheme.background || '#fff',
              zIndex: 9999,
            }),
            menuPortal: base => ({
              ...base,
              zIndex: 9999,
            }),
          }}
          theme={theme => ({
            ...theme,
            borderRadius: 8,
            colors: {
              ...theme.colors,
              primary: previewTheme.color,
              primary25: previewTheme.color + '22',
              neutral0: previewTheme.background || '#fff',
              neutral80: previewTheme.textColor || 'var(--color-text)',
            },
          })}
          menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
          menuPosition="fixed"
        />
      </div>

      {/* Color Preview */}
      <div className="flex justify-center">
        <div className="flex flex-col items-center">
          <div
            className="w-16 h-16 rounded-full border-4 border-gray-200 shadow-lg transition-colors"
            style={{ backgroundColor: previewTheme.color }}
          ></div>
          <span className="text-sm mt-3 font-medium" style={{ color: 'var(--color-text)', opacity: 0.7 }}>
            {previewTheme.name}
          </span>
        </div>
      </div>

      {/* Confirmation Buttons */}
      {showConfirmation && (
        <div className="flex gap-3 pt-4 border-t border-gray-100">
          <PrimaryButton
            onClick={handleConfirm}
            className="flex-1 px-4 py-2 rounded-lg text-sm font-medium text-white transition-colors"
            style={{ background: previewTheme.color }}
          >
            Apply Theme
          </PrimaryButton>
          <button
            onClick={handleCancel}
            className="flex-1 px-4 py-2 rounded-lg text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors"
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
}
